import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import CreateButton from "../../givBee/buttons/CreateButton";
import CancelIconButton from "../../givBee/buttons/CancelIconButton";
import { ApCreateBusinessType_Url } from "../../../provider/ServiceUrl";

class BusinessType extends Component {
  title = "Buisness Type";
  breadCrumb = [
    { pageid: "/billingPlans", uiname: "Business Type List" },
    { pageid: "", uiname: "" },
  ];
  header = store.getState().adminHeader.adminHeader;

  constructor(props) {
    super(props);

    let action = props.state.action;
    let propBusinessDomain = null;

    if (props.state && props.state) {
      propBusinessDomain = props.state.businessDomain;
    }

    this.state = {
      action: action,
      businessTypeName: "",
      businessDomain: propBusinessDomain,
      getUpdatePermission: true,
      getDeletePermission: true,
      render: false,
    };
  }

  handleBusinessTypeChange(e) {
    this.setState({ businessTypeName: e.target.value });
  }

  createBusinessTypeToBackend() {
    const postObject = {
      header: this.header,
      businessType: {
        name: this.state.businessTypeName,
        businessDomain: {
          id: this.state.businessDomain.id,
        },
      },
    };
    AdminFetchServerData.callPostService(
      ApCreateBusinessType_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.props.navigate(`/useCaseList`, {
          state: {
            action: "view",
            businessType: {
              id: output.data.businessType.id,
              name: output.data.businessType.name,
            },
            businessDomain: this.state.businessDomain,
          },
        });
      }
    });
  }

  createCancel() {
    this.props.navigate("/billingPlans", {
      state: {
        action: "create",
        businessDomain: this.state.businessDomain,
      },
    });
  }

  editCancel() {
    this.setState({ action: "view" });
  }

  render() {
    if (this.state.action === "create") {
      return this.createBusinessType();
    }
  }
  createBusinessType() {
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          businessDomain={this.state.businessDomain}
          name={this.title}
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.createBusinessTypeToBackend.bind(this)}
          >
            <div className="row" style={{ marginTop: "1em" }}>
              <div className="col-md-12">
                <div className="card" id="organizationFormCard">
                  <div className="card-body">
                    <div className="col-sm-5">
                      <div className="row mt-1">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Domain Name:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          <span>{this.state.businessDomain?.name}</span>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Buisness Type:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          <input
                            title=""
                            required
                            autoFocus={true}
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            placeholder="Business Type Name"
                            value={this.state.businessTypeName}
                            onChange={this.handleBusinessTypeChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <CreateButton btnName="Create" type="submit" />
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.createCancel()} />
              </div>
            </div>
          </ValidatorForm >
        </div >
      </>
    );
  }
}
export default withRouter(BusinessType);
